import { appendIf } from '@btime/helpers'
import i18n from 'i18next'

import moment from 'moment'

export const validatePayload = (form, validateOnlyServiceOrders) => {
  const t = i18n.getFixedT(null, ['routines', 'validations'])
  let errors = []

  const payload = typeof form.payload === 'string' ? JSON.parse(form.payload) : form.payload

  if ((!validateOnlyServiceOrders && !payload) || !payload.length) {
    errors = [
      ...appendIf(!payload?.checklist?.id, { path: ['payload'], message: t('routines:mustHaveAtLeastOneActivity') })
    ]
  } else {
    errors = payload.reduce(
      (errors, item, index) => [
        ...errors,
        ...appendIf(!item.checklist_id && !item.checklist?.id, {
          path: ['payload', index, 'checklist'],
          message: t('validations:required')
        }),
        ...appendIf(!item.place_id && !item.place?.id, {
          path: ['payload', index, 'place'],
          message: t('validations:required')
        })
      ],
      []
    )
    if (!validateOnlyServiceOrders && errors.length > 0) {
      errors = [...errors, { path: ['payload'], message: t('routines:checkActivities') }]
    }
  }

  return errors
}

export const validate = (input, setErrors) => {
  const t = i18n.getFixedT(null, ['routines', 'validations'])
  const errors = [
    ...appendIf(!input?.name, { path: ['name'], message: t('validations:required') }),
    ...appendIf(!input.frequencyIndex, { path: ['frequencyIndex'], message: t('validations:required') }),
    ...appendIf(input.frequencyIndex <= 0, {
      path: ['frequencyIndex'],
      message: t('routines:cannotBeLessOrEqualToZero')
    }),
    ...appendIf(!input.initialDate, { path: ['initialDate'], message: t('validations:required') }),
    ...appendIf(!input.id && input.initialDate && moment().diff(input.initialDate) >= 0, {
      path: ['initialDate'],
      message: t('routines:startDateMustBeGreaterThanCurrent')
    }),
    ...appendIf(
      !input.id && input.until && input.until !== 'never' && moment(input.until).isBefore(moment(input.initialDate)),
      {
        path: ['until'],
        message: t('routines:endDateMustBeGreaterThanStart')
      }
    ),
    ...validatePayload(input, false)
  ]

  setErrors(errors)
  return errors.length === 0
}
